import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class CampaignModel extends BaseModel {
  static urlPath = "leads/campaigns";

  @attr("string") name;
  @attr("boolean") active;
  @attr("string") type;
}
